import gsap from 'gsap';
import { ScrollToPlugin, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

let agileSection = document.querySelector('.agile-process');
let oldScroll = 0;
let skipBtn = document.querySelector('.step-skip');

ScrollTrigger.create({
	trigger: '.agile-process',
	start: 'top top',
	onUpdate: () => {
		let newScroll = window.scrollY;
		let up = false;

		if (newScroll > oldScroll) {
			up = true;
		}

		if (up) {
			skipBtn.innerHTML = 'Skip Process &nbsp; &darr;';
			skipBtn.dataset.direction = 'up';
		} else {
			skipBtn.innerHTML = 'Skip Process &nbsp; &uarr;';
			skipBtn.dataset.direction = 'down';
		}

		oldScroll = newScroll;
	},
});

document.querySelector('.step-skip').addEventListener('click', (event) => {
	let direction = event.target.dataset.direction;

	if (direction === 'up') {
		gsap.to(window, {
			scrollTo:
				window.scrollY +
				document
					.querySelector('.agile-process')
					.nextElementSibling.getBoundingClientRect().top,
		});
	} else {
		gsap.to(window, {
			scrollTo:
				-200 +
				window.scrollY +
				document
					.querySelector('.agile-process')
					.previousElementSibling.getBoundingClientRect().top,
		});
	}
});

export default function initAgile() {
	let matchmedia = gsap.matchMedia();
	let steps = gsap.utils.toArray('.agile-process .step');

	matchmedia.add('(min-width:750px)', () => {
		gsap.to(skipBtn, {
			opacity: 0,
			scrollTrigger: {
				trigger: document.querySelector('.steps .step:last-child'),
				scrub: true,
				start: 'top bottom',
				end: '+=2px',
			},
		});
	});

	matchmedia.add('(max-width:750px)', () => {
		steps.forEach((step, stepIndex) => {
			let cards = Array.from(step.querySelectorAll('.step-card'));
			gsap.set(step.querySelector('.step-cards'), {
				height: cards[0].clientHeight + 60 + 'px',
			});

			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: step,
					scrub: true,
					pinSpacing: true,
					start: 'top 10%',
					pin: step,
					onEnter: () => {
						if (stepIndex === steps.length - 1) {
							skipBtn.style.opacity = 0;
						}
					},
					onLeaveBack: () => {
						if (stepIndex === steps.length - 1) {
							skipBtn.style.opacity = 1;
						}
					},
					end: () =>
						'+=' +
						(step.clientHeight +
							(cards[0].clientHeight + 20) * cards.length),
				},
			});

			cards.slice(1).forEach((card, cardIndex, cards) => {
				tl.fromTo(
					cards.slice(cardIndex),
					{
						yPercent: function (index) {
							return 100 * (index + 1);
						},
					},
					{
						yPercent: function (index, target) {
							let value = 100 * (index + 1);
							return value - 100;
						},
					},
				);
			});
		});
	});
}
